import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Ezoic Auto-Ads Integration Hook for React SPAs
 *
 * This hook manages Ezoic Auto-ads (dynamic ad placement) in a Single Page Application.
 * Ezoic automatically determines optimal ad placements using machine learning.
 *
 * The hook only needs to:
 * 1. Notify Ezoic when SPA navigation occurs (route change)
 * 2. Trigger ad refresh for new page views
 *
 * Usage in App.js:
 *   useEzoic();
 *
 * Note: No placeholder IDs needed - Ezoic handles everything dynamically
 */
const useEzoic = () => {
  const location = useLocation();

  // Refresh ads on route change (SPA navigation)
  useEffect(() => {
    // Small delay to let page content render before Ezoic analyzes it
    const refreshTimer = setTimeout(() => {
      try {
        if (typeof window.ezstandalone !== 'undefined') {
          const ezoic = window.ezstandalone;

          // Refresh ads for new page view
          ezoic.refresh();
          console.log('🔄 Ezoic Auto-ads refreshed for:', location.pathname);
        }
      } catch (error) {
        console.error('❌ Ezoic refresh error:', error);
      }
    }, 100);

    return () => clearTimeout(refreshTimer);
  }, [location.pathname]); // Run on every route change
};

export default useEzoic;
